import { clsx } from 'clsx';
import {
  EscalatedStatusIcon,
  InProgressStatusIcon,
  ResolvedStatusIcon,
} from 'src/pages/ConversationsPage/ConversationList/ConversationStatusIcons';
import { MarkdownSubjectRenderer } from 'src/components/MarkdownRenderer/MarkdownSubjectRenderer';

export const ConversationSubject = ({ chat }) => {
  return (
    <>
      <div className={'flex flex-row gap-[0.625rem] overflow-hidden items-center flex-[0.8]'}>
        <p
          className={
            'text-base-sm text-ebony font-semibold overflow-ellipsis text-nowrap overflow-hidden max-h-6'
          }
        >
          <MarkdownSubjectRenderer>{chat?.subject}</MarkdownSubjectRenderer>
        </p>
      </div>
      {chat?.status === 'open' && (
        <div
          className={clsx(
            'text-base-xs font-medium flex flex-row items-center gap-[5px] py-2.5 px-4',
          )}
        >
          <p className={'text-[#009CB2]'}>{chat?.friendlyStatus}</p>
          <InProgressStatusIcon fill={'#009CB2'} selected={chat?.selected} />
        </div>
      )}
      {['closed', 'auto_closed'].includes(chat?.status) && (
        <div
          className={clsx(
            'text-base-xs font-medium flex flex-row items-center gap-[5px] py-2.5 px-4',
          )}
        >
          <p className={'text-[#389D61]'}>{chat?.friendlyStatus}</p>
          <ResolvedStatusIcon fill={'#389D61'} selected={chat?.selected} />
        </div>
      )}
      {chat?.status === 'escalated' && (
        <div
          className={clsx(
            'text-base-xs font-medium flex flex-row items-center gap-[5px] py-2.5 px-4',
          )}
        >
          <p className={'text-[#C11A45]'}>{chat?.friendlyStatus}</p>
          <EscalatedStatusIcon fill={'#C11A45'} selected={chat?.selected} />
        </div>
      )}
    </>
  );
};
